import { render, staticRenderFns } from "./MyGifts.vue?vue&type=template&id=31e17903&scoped=true&"
import script from "./MyGifts.vue?vue&type=script&lang=js&"
export * from "./MyGifts.vue?vue&type=script&lang=js&"
import style0 from "./MyGifts.vue?vue&type=style&index=0&id=31e17903&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e17903",
  null
  
)

export default component.exports